import { CRM_ENRICHMENT_CONTENT_ID } from "../constants";
import type {
    CrmEnrichmentJobObject,
    CrmEnrichmentJobRefreshPeriod,
    CrmEnrichmentJobType,
    CrmEnrichmentSource,
    CrmProvider,
    LeadScoreRefreshDataInterval,
    Operator,
} from "../types/types";

const createCrmEnrichmentI18nKeys = (provider: CrmProvider) => {
    const contentId = CRM_ENRICHMENT_CONTENT_ID[provider];

    const type = (enrichmentType: CrmEnrichmentJobType) =>
        `si.crm-enrichment.${contentId}.job-wizard.type.${enrichmentType}.title`;

    const enrichmentSource = (source: CrmEnrichmentSource) =>
        `si.crm-enrichment.job-wizard.settings.enrichment-level.${source}`;

    const object = (enrichmentObject: CrmEnrichmentJobObject | "") =>
        `si.crm-enrichment.${contentId}.job-wizard.settings.${enrichmentObject}`;

    const refreshPeriod = (period: CrmEnrichmentJobRefreshPeriod) =>
        `si.crm-enrichment.job-wizard.settings.refresh-option.${period}`;

    const leadScoreRefreshDataInterval = (interval: LeadScoreRefreshDataInterval) =>
        `si.crm-enrichment.job-wizard.settings.lead-score-refresh-option.${interval}`;

    const operator = (operatorName: Operator) => `si.crm-enrichment.job-wizard.filters.operator.${operatorName}`;

    const allEntriesFilter = (enrichmentObject: CrmEnrichmentJobObject | "") =>
        `si.crm-enrichment.${contentId}.job-wizard.filters.all-entries.${enrichmentObject}`;

    const allEntriesFilterTooltip = (enrichmentObject: CrmEnrichmentJobObject | "") =>
        `${allEntriesFilter(enrichmentObject)}.tooltip`;

    const crmFieldPlaceholder = () => `si.crm-enrichment.${contentId}.job-wizard.filters.field.placeholder`;

    return {
        type,
        enrichmentSource,
        object,
        refreshPeriod,
        leadScoreRefreshDataInterval,
        operator,
        allEntriesFilter,
        allEntriesFilterTooltip,
        crmFieldPlaceholder,
    };
};

export default createCrmEnrichmentI18nKeys;
